"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.descriptionImgNormalizer = void 0;
const mocks_json_1 = __importDefault(require("./mocks.json"));
/**
 * normalizador del modulo MODULE_DESCRIPTION_IMG_SALUD_RELOJ_TECUIDA
 * @param {object} fields
 * @returns
 */
const descriptionImgNormalizer = (data) => {
    var _a, _b;
    try {
        let resList = {};
        const moduleData = data === null || data === void 0 ? void 0 : data.fields;
        if (Array.isArray(data)) {
            data.forEach((element, index) => {
                var _a;
                let res = {};
                const moduleDataItem = element === null || element === void 0 ? void 0 : element.fields;
                // MODULE DATA
                if (moduleDataItem) {
                    const textOne = {};
                    const cardOne = {
                        layout: "",
                        textOne: {},
                        textTwo: {},
                        textThree: {},
                        imageOne: {},
                        buttonOne: {},
                    };
                    if (moduleDataItem === null || moduleDataItem === void 0 ? void 0 : moduleDataItem.title) {
                        textOne.text = moduleDataItem.title;
                    }
                    // CARD DATA
                    const cardData = moduleDataItem;
                    if (cardData) {
                        if (cardData === null || cardData === void 0 ? void 0 : cardData.alignImg) {
                            cardOne.layout = (cardData === null || cardData === void 0 ? void 0 : cardData.alignImg) || null;
                        }
                        if (cardData === null || cardData === void 0 ? void 0 : cardData.title) {
                            cardOne.textOne["text"] = cardData.title;
                        }
                        if (cardData === null || cardData === void 0 ? void 0 : cardData.subTitle) {
                            cardOne.textTwo["text"] = cardData.subTitle;
                        }
                        if (cardData === null || cardData === void 0 ? void 0 : cardData.description) {
                            cardOne.textThree["text"] = cardData.description;
                        }
                        if (cardData === null || cardData === void 0 ? void 0 : cardData.imgDesktop) {
                            cardOne.imageOne["src"] = cardData.imgDesktop;
                        }
                        // BUTTON DATA
                        const buttonData = (_a = cardData["COMPONENT_BASIC-BUTTON"]) === null || _a === void 0 ? void 0 : _a.fields;
                        if (buttonData) {
                            if (buttonData === null || buttonData === void 0 ? void 0 : buttonData.height) {
                                cardOne.buttonOne.height = buttonData.height;
                            }
                            if (buttonData === null || buttonData === void 0 ? void 0 : buttonData.href) {
                                cardOne.buttonOne.href = buttonData.href;
                            }
                            if (buttonData === null || buttonData === void 0 ? void 0 : buttonData.label) {
                                cardOne.buttonOne.label = buttonData.label;
                            }
                            if (buttonData === null || buttonData === void 0 ? void 0 : buttonData.type) {
                                cardOne.buttonOne.type = buttonData.type;
                            }
                            if (buttonData === null || buttonData === void 0 ? void 0 : buttonData.width) {
                                cardOne.buttonOne.width = buttonData.width;
                            }
                        }
                    }
                    // MERGING DATA
                    res["Text-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-1"]), textOne);
                    res["Card-1"] = {
                        ["Layout"]: cardOne.layout,
                        ["Text-1"]: Object.assign(Object.assign({}, cardOne.textOne), mocks_json_1.default["Card-1"]["Text-1"]),
                        ["Text-2"]: Object.assign(Object.assign({}, cardOne.textTwo), mocks_json_1.default["Card-1"]["Text-2"]),
                        ["Text-3"]: Object.assign(Object.assign({}, cardOne.textThree), mocks_json_1.default["Card-1"]["Text-3"]),
                        ["Image-1"]: Object.assign(Object.assign({}, cardOne.imageOne), mocks_json_1.default["Card-1"]["Image-1"]),
                        ["Button-1"]: Object.assign(Object.assign({}, cardOne.buttonOne), mocks_json_1.default["Card-1"]["Button-1"]),
                    };
                    res["category"] = moduleDataItem.category;
                }
                resList[[`DescImg-${index + 1}`]] = res;
            });
        }
        // MODULE DATA
        if (moduleData) {
            const textOne = {};
            let res = {};
            const cardOne = {
                layout: "",
                textOne: {},
                textTwo: {},
                textThree: {},
                imageOne: {},
                buttonOne: {},
            };
            if (moduleData === null || moduleData === void 0 ? void 0 : moduleData.title) {
                textOne.text = moduleData.title;
            }
            // CARD DATA
            const cardData = (_a = moduleData === null || moduleData === void 0 ? void 0 : moduleData.descriptionIMG[0]) === null || _a === void 0 ? void 0 : _a.fields;
            if (cardData) {
                if (cardData === null || cardData === void 0 ? void 0 : cardData.alignImg) {
                    cardOne.layout = (cardData === null || cardData === void 0 ? void 0 : cardData.alignImg) || null;
                }
                if (cardData === null || cardData === void 0 ? void 0 : cardData.title) {
                    cardOne.textOne["text"] = cardData.title;
                }
                if (cardData === null || cardData === void 0 ? void 0 : cardData.subTitle) {
                    cardOne.textTwo["text"] = cardData.subTitle;
                }
                if (cardData === null || cardData === void 0 ? void 0 : cardData.description) {
                    cardOne.textThree["text"] = cardData.description;
                }
                if (cardData === null || cardData === void 0 ? void 0 : cardData.imgDesktop) {
                    cardOne.imageOne["src"] = cardData.imgDesktop;
                }
                // BUTTON DATA
                const buttonData = (_b = cardData["COMPONENT_BASIC-BUTTON"]) === null || _b === void 0 ? void 0 : _b.fields;
                if (buttonData) {
                    if (buttonData === null || buttonData === void 0 ? void 0 : buttonData.height) {
                        cardOne.buttonOne.height = buttonData.height;
                    }
                    if (buttonData === null || buttonData === void 0 ? void 0 : buttonData.href) {
                        cardOne.buttonOne.href = buttonData.href;
                    }
                    if (buttonData === null || buttonData === void 0 ? void 0 : buttonData.label) {
                        cardOne.buttonOne.label = buttonData.label;
                    }
                    if (buttonData === null || buttonData === void 0 ? void 0 : buttonData.type) {
                        cardOne.buttonOne.type = buttonData.type;
                    }
                    if (buttonData === null || buttonData === void 0 ? void 0 : buttonData.width) {
                        cardOne.buttonOne.width = buttonData.width;
                    }
                }
            }
            // MERGING DATA
            res["Text-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-1"]), textOne);
            res["Card-1"] = {
                ["Layout"]: cardOne.layout,
                ["Text-1"]: Object.assign(Object.assign({}, cardOne.textOne), mocks_json_1.default["Card-1"]["Text-1"]),
                ["Text-2"]: Object.assign(Object.assign({}, cardOne.textTwo), mocks_json_1.default["Card-1"]["Text-2"]),
                ["Text-3"]: Object.assign(Object.assign({}, cardOne.textThree), mocks_json_1.default["Card-1"]["Text-3"]),
                ["Image-1"]: Object.assign(Object.assign({}, cardOne.imageOne), mocks_json_1.default["Card-1"]["Image-1"]),
                ["Button-1"]: Object.assign(Object.assign({}, cardOne.buttonOne), mocks_json_1.default["Card-1"]["Button-1"]),
            };
            resList["DescImg-1"] = res;
        }
        return resList;
    }
    catch (error) {
        console.error("ERROR!", error);
        return null;
    }
};
exports.descriptionImgNormalizer = descriptionImgNormalizer;
exports.default = exports.descriptionImgNormalizer;
//# sourceMappingURL=index.js.map